import rnuc from 'react-native-ultimate-config';

export enum Brand {
  BOTTLEMART = 'BM',
  SIPNSAVE = 'SNS',
  HARRY_BROWN = 'HB',
  THIRSTY_CAMEL = 'TC',
  DEVELOPMENT = 'DEV',
}

type Env = 'DEV' | 'BETA' | undefined;

export const config = {
  APP_NAME: rnuc.APP_NAME,
  BASE_URL: rnuc.BASE_URL,
  BASE_TENANT: rnuc.BASE_TENANT as Brand,
  HOST_DOMAIN: rnuc.HOST_DOMAIN,
  TILL_GATEWAY: rnuc.TILL_GATEWAY,
  DEFAULT_STORE: rnuc.DEFAULT_STORE,
  DEFAULT_STORE_STATE: rnuc.DEFAULT_STORE_STATE,
  SUMMER_CASH_GRAB_COMPETITION_NAME: rnuc.SUMMER_CASH_GRAB_COMPETITION_NAME,
  GIFT_CARD_STORE: rnuc.GIFT_CARD_STORE,
  FF_IS_GIFT_CARDS_ENABLED: rnuc.FF_IS_GIFT_CARDS_ENABLED,
  FF_LOYALTY_ENABLED: rnuc.FF_LOYALTY_ENABLED || false,
  GIFT_CARDS_PROMOTION_ID: rnuc.GIFT_CARDS_PROMOTION_ID,
  SUPPORT_EMAIL: rnuc.SUPPORT_EMAIL,
  KITCHENSINK_ENABLED: rnuc.KITCHENSINK_ENABLED || false,
  ONESIGNAL_APP_ID: rnuc.ONESIGNAL_APP_ID,
  WHITE_LABEL_ID: rnuc.WHITE_LABEL_ID,
  /**
   * This is used for loading mfl dev shops directly see shopSelectionStore. e.g. the app development stores
   * 'DEV'
   */
  ENV: rnuc.ENV as Env,
};

export type Config = typeof config;
export default config;